import statusReason from '@/api/hr/employee-status-reason'
import employee from '@/api/hr/employee'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return statusReason.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return statusReason.store(data)
  },

  update(context, { id, data }) {
    return statusReason.update(id, data)
  },

  destroy(context, id) {
    return statusReason.destroy(id).then(response => {
      return Promise.resolve(response)
    })
  },
  getEmployeeStatus(context, attributes = {}) {
    return employee.getStatus({ params: attributes })
  }
}
